import { useEffect, useState } from 'react';
import { api } from '../services/api';

// Admin v2 · V11 — AI usage & spend. Estimates, labeled as such; real vs
// internal split shown, never hidden. Exists so the day AI spend becomes
// material, it's already visible next to revenue.
export default function AiSpendCard() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.getAiSpend().then((r) => setData(r.data)).catch((e) => setError(e.message));
  }, []);

  if (error) return <div className="mx-6 mb-4 text-sm text-teacher-red">AI spend failed to load: {error}</div>;

  const r = data?.est_cost?.real;
  const i = data?.est_cost?.internal;

  return (
    <div className="mx-6 mb-2 bg-white border border-teacher-border rounded-xl px-5 py-4">
      <div className="flex items-baseline justify-between mb-3">
        <h3 className="text-sm font-semibold text-teacher-text-primary">
          AI usage &amp; spend · lifetime
          <span className="ml-2 text-[11px] font-medium text-teacher-text-tertiary">students only — test/internal accounts excluded, shown separately →</span>
        </h3>
        <span className="text-[11px] text-teacher-text-tertiary">estimates — blended token rate + per-solve; API bills in USD</span>
      </div>
      {!data ? (
        <div className="text-sm text-teacher-text-tertiary">Loading…</div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <div>
            <div className="text-[12px] font-medium text-teacher-text-secondary">Priya (tutor) · students</div>
            <div className="text-xl font-bold text-teacher-text-primary mt-0.5">
              {data.tutor.real.users} <span className="text-sm font-medium text-teacher-text-tertiary">students</span>
            </div>
            <div className="text-xs text-teacher-text-tertiary mt-0.5">
              {data.tutor.real.interactions} interactions · {(data.tutor.real.tokens / 1000).toFixed(0)}K tokens
            </div>
          </div>
          <div>
            <div className="text-[12px] font-medium text-teacher-text-secondary">Snap &amp; Solve · students</div>
            <div className="text-xl font-bold text-teacher-text-primary mt-0.5">
              {data.snap.real.solves} <span className="text-sm font-medium text-teacher-text-tertiary">solves</span>
            </div>
            <div className="text-xs text-teacher-text-tertiary mt-0.5">{data.snap.real.solves30d} in the last 30d</div>
          </div>
          <div>
            <div className="text-[12px] font-medium text-teacher-text-secondary">Est. spend · students</div>
            <div className="text-xl font-bold text-teacher-text-primary mt-0.5">₹{r.total_inr}</div>
            <div className="text-xs text-teacher-text-tertiary mt-0.5">${r.total_usd} · tutor ${r.tutor_usd} + snap ${r.snap_usd}</div>
          </div>
          <div>
            <div className="text-[12px] font-medium text-teacher-text-secondary">Est. spend · internal</div>
            <div className="text-xl font-bold text-teacher-text-secondary mt-0.5">₹{i.total_inr}</div>
            <div className="text-xs text-teacher-text-tertiary mt-0.5">
              {data.tutor.internal.users} accts · {data.snap.internal.solves} solves
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
